import { Component, OnInit } from '@angular/core';
import { CupService } from '../../shared/services/cup.service';
import { UrlconstantsService } from '../../shared/services/urlconstants.service';
import { urls } from '../../common/model/properties';

//import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
//import * as jsPDF from 'jspdf'; 
import { jsPDF } from 'jspdf';
import { PcpScorecardService } from './pcp-scorecard.service';
import { SecureStorageService } from '../../secure-storage.service';
import {Modal} from 'bootstrap';

@Component({
    selector: 'app-pcp-scorecard',
    templateUrl: './pcp-scorecard.component.html',
    styleUrls: ['./pcp-scorecard.component.css'],
    standalone: false
})
export class PcpScorecardComponent implements OnInit {
  selectedSite: any;
  sites: any[];
  public urlConstant: any = this.urlconstantsService.fetchUrl();
  showSpinner = false;
  showView: boolean;
  providers: any[] = [];
  showProviders = false;
  diseasesList: Array<any> = [];
  selectedProviderModel: any;
  pcpDropdownforDCE: boolean= false;
  public showCollapseAll: boolean = false;
  public sitePlaceHolder: string;
  measureList: Array<any> = [];
  medicalMeasureList: Array<any> = [];
  public providerAffiliationList: any[];
  pcpChanged: boolean;
  selectedProvider: any;
  loadProviderAffiliationSubscription: any;
  data = [];
  pcpscorecard: boolean = false;
  pcpdetails = [];
  diseasesList51: Array<any> = [];	
  diseasesList52: Array<any> = [];	
  diseasesList53: Array<any> = [];	
  diseasesList57: Array<any> = [];	
  diseasesList58: Array<any> = [];
  showNoRecords: boolean;
  pdfPcpId: any;

  finalMeasureList: Array<any> = [];	
  public qmDataGrpByMember = {};	
  memlength = [];

  opmrData = [];
  uniqueMonth = [];
  dropdownYear = [];
  omprFinalData = [];
  rows = [];
  headrows = [];
  latestdate;




  handleResults(searchObj) {
    this.data = searchObj;
  }

  constructor(
    private cupService: CupService,
    private urlconstantsService: UrlconstantsService,
    private pcpscorecardService: PcpScorecardService,
    private secureStorage:SecureStorageService
  ) { }

  ngOnInit() {
    this.getExternalDashboard();
    this.getPCPProviders();
  }

  head = [['Category', 'PCP', 'Neighborhood', 'Region']]
   newhead = [
    [
        {content: 'People', colSpan: 3, styles: {fillColor: '#000000'}}, 
        {content: 'Data', colSpan: 2, styles: {fillColor: '#000000'}}
    ],
    ['CategoryNew', 'PCP', 'Neighborhood', 'Region','Benchmark']
];

   createPdf() {  
    this.rows = [];
    this.headrows = [];  
    var doc = new jsPDF();
    let img = new Image();
    img.src = "/assets/images/CareMore.png"
      

    const header = function(headerData: any) {
      doc.addImage(img, 'PNG', 10, 10, 50, 20);

      doc.setFontSize(12);
      const currentdate = new Date();
      const datetime = (currentdate.getMonth() + 1)+ '/' + currentdate.getDate() + '/' + currentdate.getFullYear();
      doc.text('Reportdate: ' + datetime, 150, 20);
      
    };  

    this.omprFinalData.forEach(async (member) => {
      this.headrows.push([
        {content: 'PCP PERFORMANCE TRACKING', colSpan: 3, styles: {halign: 'center', fillColor: [255,255,255],textColor: [0, 0, 0],fontSize:18}},
      ])   
      //this.headrows.push([{ }]); 
      this.headrows.push([
        {content: this.pcpdetails[0].pcpname, colSpan: 1, styles: {fillColor: [255,255,255],textColor: [0, 0, 0],fontStyle: 'normal'}}, 
        {content: 'Region :'+this.pcpdetails[0].pcpregion, colSpan: 2, styles: {fillColor: [255,255,255],textColor: [0, 0, 0],fontStyle: 'normal'}}
    ]);
    this.headrows.push([
      {content: this.pcpdetails[0].pcpaddress, colSpan: 1, styles: {fillColor: [255,255,255],textColor: [0, 0, 0],fontStyle: 'normal'}}, 
      {content: 'Neighborhood :'+this.omprFinalData[0].neighborhood, colSpan: 2, styles: {fillColor: [255,255,255],textColor: [0, 0, 0],fontStyle: 'normal'}}
    ]);
    //this.headrows.push([['CategoryNew', 'PCP', 'Neighborhood', 'Region','Benchmark']])
    this.headrows.push([
      {content:'Category'},
      {content: 'PCP'},
      // {content: 'Neighborhood'},
      // {content:'Region'},
      {content:'Benchmark'}])
 
     this.rows.push( 
      [{content: 'Data: Between '+ this.omprFinalData[0].opmrbdt+'-'+this.omprFinalData[0].opmredt, colSpan: 3, styles: { halign: 'left',fillColor: '#6495ED',textColor:'black' } }]
     );
    //  this.rows.push(['MLR',this.omprFinalData[0] ? this.omprFinalData[0].mlr: " ", " "]);  
     this.rows.push(['Pharmacy Total Scripts PMPM', this.omprFinalData[0] ? this.omprFinalData[0].pharmacyTotalScriptsPMPM: " ", " "]);
     this.rows.push(['Rx Generic Utilization %', this.omprFinalData[0] ? this.omprFinalData[0].pharmacyGenericUtilization: " ", " "]);
     this.rows.push(['ER Visits PTMPY', this.omprFinalData[0] ? this.omprFinalData[0].erVisitsPTMPY: " ", " "]);
     this.rows.push(['Urgent Care Visits PTMPY', this.omprFinalData[0] ? this.omprFinalData[0].urgentCareVisitsPTMPY: " ", " "]);
     this.rows.push(['CCC Visits PTMPY', this.omprFinalData[0] ? this.omprFinalData[0].cccVisitsPTMPY: " ", " "]);
     this.rows.push(['Encounter Data PMPY', this.omprFinalData[0] ? this.omprFinalData[0].careMoreEncountersPMPY: " ", " "]);
     this.rows.push([{content: 'Overall STAR Rating [Part C (HEDIS/HOS) + Part D]: As of '+this.latestdate, colSpan: 3, styles: { halign: 'left',fillColor: '#6495ED',textColor:'black' } }]);
     this.rows.push(['Overall Star Rating', this.omprFinalData[0] ? this.omprFinalData[0].overallStarRating: " ", " "]);
    //  this.rows.push([{content: 'Part D Measures: Between '+this.latestdate+'-'+this.latestdate, colSpan: 3, styles: { halign: 'left',fillColor: '#6495ED',textColor:'black' } }]);
    //  this.rows.push(['Medication Adherence - Diabetes (OralDb)', this.diseasesList53[0] ? this.diseasesList53[0].ratecomplete+'%' : " ", " ", " ",this.diseasesList53[0] ? this.diseasesList53[0].targetGoal : " "]);
    //  this.rows.push(['Medication Adherence - Hypertension (RAS Antagonists))',this.diseasesList51[0] ? this.diseasesList51[0].ratecomplete+'%': " ", " ", " ",this.diseasesList51[0] ? this.diseasesList51[0].targetGoal: " "]);
    //  this.rows.push(['Medication Adherence - Cholesterol (Statins)',this.diseasesList52[0] ? this.diseasesList52[0].ratecomplete+'%' : " ", " ", " ",this.diseasesList52[0] ? this.diseasesList52[0].targetGoal : " "]);
    //  this.rows.push(['Statin Use in Persons with Diabetes',this.diseasesList58[0] ?this.diseasesList58[0].ratecomplete+'%' : " ", " ", " ",this.diseasesList58[0] ? this.diseasesList58[0].targetGoal : " "]);
    //  this.rows.push(['Statin Use in Persons with Cardiovascular Disease',this.diseasesList57[0] ? this.diseasesList57[0].ratecomplete+'%' : " ", " ", " ",this.diseasesList57[0] ? this.diseasesList57[0].targetGoal : " "]);
     this.rows.push([{content: 'Membership: As of '+this.latestdate, colSpan: 3, styles: { halign: 'left',fillColor: '#6495ED',textColor:'black' } }]);
     this.rows.push(['Membership', this.memlength.length,"NA"]);

   });

    (doc as any).autoTable({
      head: this.headrows,
      body: this.rows,
      margin: {top: 40}, 
      beforePageContent: header,
      // columnStyles: {
      //   0: {
      //     cellWidth: 30,
      //   },
      //   1: {
      //     cellWidth: 30,
      //   },
      //   2: {
      //     cellWidth: 10,
      //   },
      //   3: {
      //     cellWidth: 10,
      //   },
      //   4: {
      //     cellWidth: 20,
      //   },
      // },
      theme: 'grid',
      headStyles :{fillColor : '#0C3B75'},
      didDrawCell: data => {
      }
    })

    doc.save('PCP_ScoreCard_'+this.pdfPcpId+'.pdf');
}

  getExternalDashboard() {
    this.sites = []; 
    this.pcpscorecard = false;   
    const username = this.cupService.getUserNameFromJWT();
    const url = this.urlConstant.providerDashboard ;    
    this.showSpinner = true;
    this.cupService.retrieveData('post', url).subscribe(
      data => {
        if (data != null) {
          // this.sites = data.sites;
          if (data.sites && data.sites.length) {
            data.sites.map(element => {
              this.sites.push({
                'id': element.siteUid,
                'value': element.siteName,
                'label': element.siteName
              })
            });
          }
          this.showView = true;
        }
        this.showSpinner = false;
      },
      error => {
        this.showSpinner = false;
      }
    );
  }

  pcpAllSites = [];
  getPCPProviders() {
    let userNameFromToken = this.cupService.getUserNameFromJWT();
    this.providers = [];
    //this.activatedMenu = this.items[0];
    this.showProviders = false;
    const siteDetailURL = this.urlConstant.userSiteProviders.replace(
      '{id}',
      userNameFromToken
    );
    setTimeout(() => {
      this.showSpinner = true;
    }, 100);
    let checkDuplicates = [];
    this.cupService.retrieveData('post', siteDetailURL).subscribe(
      siteData => {
        if (siteData && siteData.length) {          
          siteData.map(each => {
            if(each.providers && each.providers.length > 0){
            let providerIds = [];
            each.providers.map(element => {
              if (element.pcp && element.region.indexOf("OBSOLETE") === -1) {
                element.value =
                  element.name +
                  "\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0" +
                  element.region +
                  "\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0" + element.address.substring(0, 14);
                element.providerUid = element.id;
                element.id = element.providerId;
                if (!checkDuplicates.includes(element.value)) {
                  checkDuplicates.push(element.value);
                  this.providers.push(element);
                }
                if (!providerIds.includes(element.providerId)) {
                  providerIds.push(element.providerId);
                }
              }
            });
            this.pcpAllSites.push({
              value: { id: each.siteUid, value: each.name },
              uid: providerIds
            });
          }
          });
        } else {
          this.diseasesList = [];
        }
        this.showProviders = true;
        this.showSpinner = false;

      },
      error => {
        this.showSpinner = false;
      }
    );
  }

  setProviders(e) {
    this.selectedSite = e;
   if (e.value === "DCE-CMMI Providers") {
     this.pcpDropdownforDCE = true;
    this.openModal('CMMIDCEMessageModal');
     }
    this.showCollapseAll = false;
    this.sitePlaceHolder = '';
    this.providers = [];
    this.diseasesList = [];
    this.measureList = [];
    this.medicalMeasureList = [];
    this.providerAffiliationList = [];
    //this.unsubscribeAll();
    this.setExternalProviders();    
    this.pcpChanged = true;
    //this.providerAffiliationList = [];
  }

  setExternalProviders() {
    this.providers = [];
    //this.activatedMenu = this.items[0];
    this.showProviders = false;
    const siteDetailURL = this.urlConstant.userSiteGet.replace(
      '{siteUid}',
      this.selectedSite.id
    );
    this.showSpinner = true;
    let checkDuplicates = [];
    this.cupService.retrieveData('get', siteDetailURL).subscribe(
      siteData => {
        if (siteData) {
          //console.log("siteData :",siteData)
          //if (siteData.siteProviderConfig && !(_.isEmpty(siteData.siteProviderConfig))) {
            if (siteData.siteProviderConfig && siteData.siteProviderConfig != null) {
            //  this.providers = siteData.siteProviderConfig;
            siteData.siteProviderConfig.map(element => {
              if (element.neighborhood && element.pcp && element.region.indexOf("OBSOLETE") === -1) {
                element.value =
                  element.name +
                  "\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0" +
                  element.region +
                  "\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0" + element.address.substring(0, 14);
                element.providerUid = element.id;
                element.id = element.providerId;
                if (!checkDuplicates.includes(element.value)) {
                  checkDuplicates.push(element.value);
                  this.providers.push(element);
                }
              }
            });
            // this.selectedProvider = this.providers[0];
            // this.onProvidersSubmit(this.selectedProvider);
          } else {
            this.diseasesList = [];
          }
        }
        this.showProviders = true;
        this.showSpinner = false;
      },
      error => {
        this.showSpinner = false;
      }
    );
  }

  private getProviderInfoByValue(providerUid) {

    if (this.providers && this.providers.length > 0) {    
      return this.providers.find(x => x.value == providerUid);
    }
  }

  public onProvidersSubmit(selectedProvider) {
    this.showCollapseAll = false;
    this.diseasesList = [];
    this.measureList = [];
    this.medicalMeasureList = [];
    this.pcpdetails = [];
    this.pdfPcpId = '';
    if (selectedProvider != undefined) {
      if (!this.pcpChanged) {
        //const pcp = _.find(this.pcpAllSites, (each => {
          const pcp = this.pcpAllSites.find((each => {
          if (each.uid.includes(selectedProvider.id)) {
            return each;
          }
        }));
        this.selectedSite = pcp.value;
      }
      let provider = this.getProviderInfoByValue(selectedProvider.value);
      this.selectedProvider = provider;
      //console.log("provider details from get fun :",provider)
      //this.activatedMenu = this.items[0];
      const regionCode = provider.regionCode;
      const id = provider.id + regionCode;
      this.pdfPcpId = provider.id;
      const body = {
        siteId: this.selectedSite ? this.selectedSite.id : '',
        providerdId: provider ? provider.id : ''
      };
      this.pcpdetails.push({
        pcpname : provider.name,
        pcpaddress: provider.address,
        pcpregion : provider.region,
        pcpneighborhood : provider.neighborhood
      });    
      //console.log("Printing pcpdetails :",this.pcpdetails)
      this.showSpinner = true;
      this.diseasesList = [];
      this.measureList = [];
      this.medicalMeasureList = [];
      this.providerAffiliationList = [];
      this.loadProviderAffiliation(provider.providerUid);
      setTimeout(() => {
        this.getQmDashboardMemberData(id)
      }, 1000);
      
      //this.providerId = id;
      //this.getQmDashboardData(id);
      this.getOPMRData(provider.id);
      this.showSpinner = false;
    }
  }

  generatePCPScoreCard() {
    this.showSpinner = true;
    this.pcpscorecard = true;
    this.showSpinner = false;
  }

  private loadProviderAffiliation(providerUid) {
    this.showSpinner = true;
    this.pcpscorecard = false
    let jsonData = JSON.stringify({
      id: providerUid,
      affiliationType: [
        "P TO G",
        "P TO I"
      ]
    });
    if (this.loadProviderAffiliationSubscription) {
      this.loadProviderAffiliationSubscription.unsubscribe();
    }
    this.loadProviderAffiliationSubscription = this.cupService.retrieveData('post', urls.providerAffiliation, jsonData).subscribe(data => {
      if (Array.isArray(data)) {
        //console.log("providerAffiliationList -- :",data)
        this.providerAffiliationList = data;
      }
    });
    this.showSpinner = false;
  }

  private unsubscribeAll() {
    // if (this.loadQMDataSubscription) {
    //   this.loadQMDataSubscription.unsubscribe();
    // }
    if (this.loadProviderAffiliationSubscription) {
      this.loadProviderAffiliationSubscription.unsubscribe();
    }
    // if (this.loadExternalUserSiteSubscription) {
    //   this.loadExternalUserSiteSubscription.unsubscribe();
    // }
    // if (this.loadInternalUserSiteSubscription) {
    //   this.loadInternalUserSiteSubscription.unsubscribe();
    // }
    // if (this.loadProviderSubscription) {
    //   this.loadProviderSubscription.unsubscribe();
    // }
    // if (this.queryParamsSub) {
    //   this.queryParamsSub.unsubscribe();
    // }
    // if (this.starRatingSubscription) {
    //   this.starRatingSubscription.unsubscribe();
    // }
  }

  async getQmDashboardMemberData(provider: any) {
    //this.membersList: Array<any> = {};
    //this.measureStatusList = [];
    this.qmDataGrpByMember = [];
    const regionCode = provider.regionCode;
    //this.memberNameList = [];
    //this.memberWithMedicalAdherenceMeasureData = [];

    // this.diseasesList = [];
    // this.measureList = [];
    // this.finalMeasureList = [];
    // this.medicalMeasureList = [];
    this.showSpinner = true;
    this.memlength = [];

    return this.cupService.retrieveData("get",
      this.urlConstant.qmMemberListView + provider
    )
      .subscribe(
        data => {
          if (data) {
          //console.log("total count of member :",data)
            data.memberMeasures.forEach(row => {
              let list = [];
              row.memberDetails.forEach(member => {
                let obj: any = {};
                obj.measure = row.measure;
                obj.measureId = row.measureId;
                obj.hedisMeasure = '';
                obj.membername = member.firstName + ' ' + member.lastName;

                obj.memberId = member.memberId;
                obj.dob = member.dob;
                obj.gender = member.gender;
                obj.age = member.age;
                obj.memberAddress = member.memberAddress;
                obj.healthPlan = member.memberHealthPlan && member.memberHealthPlan.length > 0 ? member.memberHealthPlan[0] : {};
                //obj.eventdate = member.memberQmDetails.length ? this.dateService.convertDateFormat(member.memberQmDetails[0].eventDate) : ' ';
                obj.eventvalue = member.memberQmDetails.length ? member.memberQmDetails[0].eventValue : '';
                obj.exclusionNote = member.memberQmDetails.length ? member.memberQmDetails[0].excludedNote : '';
                obj.status = member.memberQmDetails.length ? member.memberQmDetails[0].status : '';
                obj.statusDesc = member.memberQmDetails.length ? member.memberQmDetails[0].statusDesc : '';
                list.push(obj);
                
                this.memlength = Object.keys(this.qmDataGrpByMember); // Return mem id list
                //console.log("printing length of keys :",this.memlength.length);
               
                let isMemberAddedAlready = false;
                if (this.memlength && this.memlength.length > 0) {
                  isMemberAddedAlready = this.memlength.find(key => member.memberId == key) ? true : false;
                }

                if (!isMemberAddedAlready) {
                  this.qmDataGrpByMember[member.memberId] = {
                    memberId: member.memberId,
                    membername: member.firstName + ' ' + member.lastName,
                    dob: member.dob,
                    pcpName: this.selectedProvider.name,
                    measures: [
                      {
                        measureId: row.measureId,
                        measure: row.measure,
                        dueDate: obj.eventdate,
                        eventValue: obj.eventvalue,
                        status: obj.status,
                        eventNotes: obj.statusDesc,
                        excludedNote: obj.exclusionNote,
                      }
                    ]
                  }
                 
                } else {
                  let memberWithMeasureData = this.qmDataGrpByMember[member.memberId];
                  if (!memberWithMeasureData.measures) {
                    memberWithMeasureData.measures = [];
                  }
                  if (row.measure != 'Medication Adherence - Diabetes (OralDb)') {
                    (<any[]>memberWithMeasureData.measures).push({
                      measureId: row.measureId,
                      measure: row.measure,
                      dueDate: obj.eventdate,
                      eventValue: obj.eventvalue,
                      status: obj.status,
                      eventNotes: obj.statusDesc,
                      excludedNote: obj.exclusionNote,
                    });
                  }
                  // let memberWithMeasureData = this.qmDataGrpByMember[member.memberId];
                  // if (!memberWithMeasureData.measures) {
                  //   memberWithMeasureData.measures = [];
                  // }
                  // if (row.measure != 'Medication Adherence - Diabetes (OralDb)' &&  
                  //     row.measure != 'Medication Adherence ACE/ARB' &&  
                  //     row.measure != 'Medication Adherence Statin'
                  // ) {
                  //   (<any[]>memberWithMeasureData.measures).push({
                  //     measureId: row.measureId,
                  //     memberName:  member.firstName + ' ' + member.lastName,
                  //     measure: row.measure,
                  //     dueDate: obj.eventdate,
                  //     eventValue: obj.eventvalue,
                  //     status: obj.status,
                  //     eventNotes: obj.statusDesc,
                  //     excludedNote: obj.exclusionNote,
                  //   });
                  //   this.memberWithNormalMeasureData.push({
                  //     measureId: row.measureId,
                  //     memberName:  member.firstName + ' ' + member.lastName,
                  //     measure: row.measure
                  //   });
                  // }
                  // if (row.measure == 'Medication Adherence - Diabetes (OralDb)' ||  
                  //     row.measure == 'Medication Adherence ACE/ARB' ||
                  //     row.measure == 'Medication Adherence Statin'
                  // ) {
                  //   this.memberWithMedicalAdherenceMeasureData.push({
                  //     measureId: row.measureId,
                  //     memberName:  member.firstName + ' ' + member.lastName,
                  //     measure: row.measure
                  //   });
                  // }
                  //onsole.log( this.memberWithMedicalAdherenceMeasureData);
                }


        
              });


            });

            //this.showTabs = true;
            //this.keys = Object.keys(this.qmDataGrpByMember);
                    }
          // this.getStarRating();
          this.showSpinner = false;
          // console.log("this.showSpinner ==:",this.showSpinner)

        });
       
  }

  public getQmDashboardData(selectedProvider) {
    //console.log("entered getQmDashboardData :",selectedProvider);
    //const regionCode = selectedProvider.regionCode;
    this.showNoRecords = false;
    this.diseasesList = [];
    this.diseasesList51 = [];
    this.diseasesList52 = [];
    this.diseasesList53 = [];
    this.diseasesList57 = [];
    this.diseasesList58 = [];
    this.measureList = [];
    this.medicalMeasureList = [];
    const pcpmeasurelist = [51,52,53,57,58];
    this.showSpinner = true;
    return this.cupService.retrieveData("get", this.urlConstant.qmDashboard + selectedProvider)
      .subscribe(data => {
        if (data) {
          //console.log("qmDashboard data---:",data)
          let index = 0;
          data.measures.map((items, i) => {
            //console.log("getQmDashboardData --items.measureDetails :",items)
            items.measureDetails.forEach((disease) => {
              pcpmeasurelist.forEach((item) => {
                if(item == items.measureId) {
                  disease['measureId'] = items.measureId;
                  disease["metPercentage"] = Math.round(
                    (disease["numerator"] / disease.denominator) * 100
                  );
                  disease["notMet"] = disease.denominator - disease.numerator;
              
                  disease["notMetPercentage"] = Math.round(
                    (disease["NotMet"] / disease.denominator) * 100
                  );
                  const average = Math.round(
                    (disease.numerator / disease.denominator) * 100
                  );
                  disease["metAverage"] = average;
                  
                  const withoutReverseGraph = disease.targetPercentage == 100 ? (disease.targetPercentage + '%') : (disease.targetPercentage + '% - 100%');
                  disease.targetGoal = withoutReverseGraph;
                  disease.starRating = -1;// Represent no star rating assigned
                  //this.diseasesList.push(disease);
                  //console.log("items.measureId --:",items.measureId)
                  if(items.measureId == 51) {
                    this.diseasesList51.push({
                      id: index,
                      itemName: disease.dashboardDescription,
                      measureId: items.measureId,
                      targetGoal: disease.targetGoal,
                      ratecomplete: disease["metPercentage"]
                    });
                  }
                  if(items.measureId == 52) {
                    this.diseasesList52.push({
                      id: index,
                      itemName: disease.dashboardDescription,
                      measureId: items.measureId,
                      targetGoal: disease.targetGoal,
                      ratecomplete: disease["metPercentage"]
                    });
                  }
                  if(items.measureId == 53) {
                    this.diseasesList53.push({
                      id: index,
                      itemName: disease.dashboardDescription,
                      measureId: items.measureId,
                      targetGoal: disease.targetGoal,
                      ratecomplete: disease["metPercentage"]
                    });
                  }
                  if(items.measureId == 57) {
                    this.diseasesList57.push({
                      id: index,
                      itemName: disease.dashboardDescription,
                      measureId: items.measureId,
                      targetGoal: disease.targetGoal,
                      ratecomplete: disease["metPercentage"]
                    });
                  }
                  if(items.measureId == 58) {
                    this.diseasesList58.push({
                      id: index,
                      itemName: disease.dashboardDescription,
                      measureId: items.measureId,
                      targetGoal: disease.targetGoal,
                      ratecomplete: disease["metPercentage"]
                    });
                  }
                }
             })
            });
          }); 
          if (data.measures.length == 0) {
            //this.showNoRecords = true;
          }        
        }
      });
  }

  public getOPMRData(id)  {
    this.showNoRecords = false;
    this.opmrData = [];
    this.uniqueMonth = [];
    this.dropdownYear = [];
    this.latestdate = '';
    this.omprFinalData = [];

    this.pcpscorecardService.getPCPScoreCardDetails(id).subscribe(data => {
      if(data) {      
        let res:any;
        res= data.pcpScoreCard;        
        res.map((ele, index) => {
          let obj: any = {};
          obj.incurredMonth = ele.incurredMonth;
          obj.pharmacyGenericUtilization = ele.pharmacyGenericUtilization;
          obj.erVisitsPTMPY = ele.erVisitsPTMPY;
          obj.pharmacyTotalScriptsPMPM = ele.pharmacyTotalScriptsPMPM;
          obj.urgentCareVisitsPTMPY = ele.urgentCareVisitsPTMPY;
          obj.cccVisitsPTMPY = ele.cccVisitsPTMPY;
          obj.mlr = ele.mlr;
          obj.careMoreEncountersPMPY = ele.careMoreEncountersPMPY;
          obj.overallStarRating = ele.overallStarRating;
          obj.encounterBeginDate = ele.encounterBeginDate;
          obj.encounterEndDate = ele.encounterEndDate;
          obj.opmrBeginDt = ele.opmrBeginDt;
          obj.opmrEndDt = ele.opmrEndDt;
          obj.neighborhood = ele.neighborhood;
          this.opmrData.push(obj);          
        })
        

        if (this.opmrData && this.opmrData.length) {
          this.opmrData.filter((element,index) => {              
            if(element.incurredMonth ) {                  
              this.uniqueMonth.push({
                id: index,
                itemName: (element.incurredMonth).substring(0, 10)
              })
            }
          })


          const maxDate = this.uniqueMonth.reduce((acc,date)=>{return acc && new Date(acc)>new Date(date)?acc:date},'')          
          this.latestdate = this.formatDate(maxDate.itemName);
          this.selectedYear(maxDate);         
         }  
         else {
          this.omprFinalData = [];
          this.showNoRecords = true;
         }      
      }
      else {       
        this.omprFinalData = [];
        this.showNoRecords = true;
      }
    })

  }


  selectedYear(maxdate: any) {
    this.omprFinalData = [];
 
    this.opmrData.filter((ele) => {   
      if((ele.incurredMonth).substring(0, 10) == maxdate.itemName) {                  
        this.omprFinalData.push({
          incurredMonth : ele.incurredMonth,
          pharmacyGenericUtilization : ele.pharmacyGenericUtilization,
          erVisitsPTMPY : ele.erVisitsPTMPY,
          pharmacyTotalScriptsPMPM : ele.pharmacyTotalScriptsPMPM,
          urgentCareVisitsPTMPY : ele.urgentCareVisitsPTMPY,
          cccVisitsPTMPY : ele.cccVisitsPTMPY,
          mlr : ele.mlr,
          neighborhood : ele.neighborhood,
          careMoreEncountersPMPY : ele.careMoreEncountersPMPY,
          overallStarRating : ele.overallStarRating,
          encounterBeginDate : (ele.encounterBeginDate).substring(0, 10),
          encounterEndDate : (ele.encounterEndDate).substring(0, 10),
          opmrBeginDt : (ele.opmrBeginDt).substring(0, 10),
          opmrEndDt : (ele.opmrEndDt).substring(0, 10),   
          opmrbdt : this.formatDate((ele.opmrBeginDt).substring(0, 10)),
          opmredt : this.formatDate((ele.opmrEndDt).substring(0, 10))               
        })     
      }
    })    
  
  }

  formatDate(date: any) {
    if(!date)
      return '';
    date = date.replace(/-+/g, '-');
    var array = (date || '').toString().split(/\-/g);
    let dateFormat = array[1]+ '/' + array[2] + '/' + array[0];
    return dateFormat;
  };

  openModal(modalId: string) {
                const modal = new Modal(document.getElementById(modalId));
                modal.show();
            }
            
            closeModal(modalId: string) {
              const modalElement = document.getElementById(modalId);
                const  modal = Modal.getInstance(modalElement);
                if(modal!=null){
                  modal.hide();
                }
            }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }

}
